import React from "react";
import styles from "./AssistantGalleryMessage.module.css";
import {ChatHistoryDTO, MessageType, WidgetAppearanceLocaleVariantUi} from "../../../../../../../../api/generated";
import {MessageTime} from "../../messageTime/MessageTime";
import {TextInMarkdown} from "../../../../../../../elements/textInMarkdown/TextInMarkdown";
import {VehicleSlider} from "./components/vehicleSlider/VehicleSlider";

interface AssistantGalleryMessageProps {
    chatHistory: ChatHistoryDTO
    widgetAppearanceSettings: WidgetAppearanceLocaleVariantUi
}

export const AssistantGalleryMessage: React.FC<AssistantGalleryMessageProps> = ({
                                                                                    chatHistory,
                                                                                    widgetAppearanceSettings
                                                                                }) => {
    return <div key={chatHistory.id} className={styles.wrapper}>
        <div className={styles.textWrapper}>
            <MessageTime timestamp={chatHistory.timestamp}/>
            <span className={styles.messageContent} style={{backgroundColor: widgetAppearanceSettings.brandColour}}>
                <TextInMarkdown text={chatHistory.message}/>
            </span>
        </div>
        {chatHistory.messageType === MessageType.Gallery && <div className={styles.galleryWrapper}>
            <VehicleSlider
                brandColour={widgetAppearanceSettings.brandColour}
                vehicles={chatHistory.vehicleDataList!}
            />
        </div>}
    </div>
}
